export default {
  title: "Mise à jour de l'heure !",
  labels: {
    old_time: 'Heure de retrait précédente :',
    new_time: 'Nouvelle heure de retrait :',
  },
  buttons: {
    print: 'Imprimer & Fermer',
    got_it: 'Compris',
  },
  feedback: {
    new_prep_time:
      "L'heure de livraison a été mise à jour. Veuillez ajuster votre planning de préparation en conséquence.",
  },
  toasts: {
    something_went_wrong: "Une erreur s'est produite, veuillez réessayer",
  },
};
